"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.calculateInitialState = exports.getIsStageContentPartial = exports.concatClassnames = void 0;
var elements_1 = require("./elements"),
  math_1 = require("./math"),
  concatClassnames = function () {
    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
    return t.filter(Boolean).join(" ");
  },
  getIsStageContentPartial = (exports.concatClassnames = concatClassnames, function (t, e, i) {
    return void 0 === e && (e = 0), void 0 === i && (i = 0), !(t = void 0 !== t && t) && i <= e;
  }),
  calculateInitialState = (exports.getIsStageContentPartial = getIsStageContentPartial, function (t, e, i) {
    void 0 === i && (i = (0, elements_1.canUseDOM)());
    var n,
      a,
      o = t.animationDuration,
      o = void 0 === o ? 0 : o,
      s = t.infinite,
      s = void 0 !== s && s,
      l = t.autoPlay,
      l = void 0 !== l && l,
      r = t.autoWidth,
      r = void 0 !== r && r,
      m = (0, elements_1.createClones)(t),
      d = (0, elements_1.getTransitionProperty)(),
      c = (0, elements_1.getItemsCount)(t),
      u = (0, elements_1.getItemsOffset)(t),
      f = (0, elements_1.getItemsInSlide)(c, t),
      g = (0, math_1.getStartIndex)(t.activeIndex, c),
      g = (0, math_1.getActiveIndex)({
        startIndex: g,
        itemsCount: c,
        infinite: s
      }),
      S = (0, elements_1.getElementDimensions)(e).width,
      I = (a = (e = (r ? (n = (e = (0, elements_1.createAutowidthTransformationSet)(e, S, s)).coords, a = e.content, e) : (n = (e = (0, elements_1.createDefaultTransformationSet)(m, S, f, s)).coords, a = e.content, e)).partial, a), (0, math_1.getItemCoords)(-f, n = n).position),
      _ = (0, math_1.getSwipeLimitMin)({
        itemsOffset: u,
        transformationSet: n
      }, t),
      t = (0, math_1.getSwipeLimitMax)({
        itemsCount: c,
        itemsOffset: u,
        itemsInSlide: f,
        transformationSet: n
      }, t),
      h = (0, math_1.getSwipeShiftValue)(c, n);
    return {
      activeIndex: g,
      autoWidth: r,
      animationDuration: o,
      clones: m,
      infinite: s,
      itemsCount: c,
      itemsInSlide: f,
      itemsOffset: u,
      translate3d: (0, elements_1.getTranslate3dProperty)(g, {
        itemsInSlide: f,
        itemsOffset: u,
        transformationSet: n,
        autoWidth: r,
        infinite: s
      }),
      stageWidth: S,
      stageContentWidth: a,
      initialStageHeight: 0,
      isStageContentPartial: e,
      isAutoPlaying: l,
      isAutoPlayCanceledOnAction: !1,
      transformationSet: n,
      transition: d,
      fadeoutAnimationIndex: null,
      fadeoutAnimationPosition: null,
      fadeoutAnimationProcessing: !1,
      swipeLimitMin: _,
      swipeLimitMax: t,
      swipeAllowedPositionMax: I,
      swipeShiftValue: h,
      canUseDom: i
    };
  });
exports.calculateInitialState = calculateInitialState;